import { render } from "./citizens.vue?vue&type=template&id=70e1ab89"
import script from "./citizens.vue?vue&type=script&lang=js"
export * from "./citizens.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__